module.exports = __webpack_public_path__ + "img/w11-b2.5b00695d.jpg";